const ACCEPTABLE_FORMATS = {
  // Documents
  'pdf': { type: 'pdf', icon: 'pdf' },
  'doc': { type: 'doc', icon: 'doc' },
  'docx': { type: 'docx', icon: 'doc' },
  'xls': { type: 'xls', icon: 'xls' },
  'xlsx': { type: 'xlsx', icon: 'xls' },
  
  // Images
  'jpeg': { type: 'jpg', isImage: true },
  'jpg': { type: 'jpg', isImage: true },
  'png': { type: 'png', isImage: true },
};

// Available SVG icons in assets/img
const AVAILABLE_ICONS = ['pdf', 'doc', 'docx', 'xls', 'xlsx'];

export const getFileExt = (filename) => {
  if (!filename) return '';
  return filename.split('.').pop().toLowerCase();
};

export const getFileType = (filename) => {
  const ext = getFileExt(filename);
  const format = ACCEPTABLE_FORMATS[ext];
  return format ? format.type.toUpperCase() : ext.toUpperCase();
};

export const getFileIcon = (filename) => {
  const ext = getFileExt(filename);
  const format = ACCEPTABLE_FORMATS[ext];
  return format ? format.icon : null;
};

export const hasFileIcon = (filename) => {
  const icon = getFileIcon(filename);
  return AVAILABLE_ICONS.includes(icon);
};

export const isImageFile = (filename) => {
  const ext = getFileExt(filename);
  const format = ACCEPTABLE_FORMATS[ext];
  return format && format.isImage;
};

export const getFilePreviewUrl = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
};
